var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSystemUiconsExternal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0953 6.47627V2.66675M14.0953 2.66675H10.2858M14.0953 2.66675L8.76199 8.00008M8.00008 2.66675H4.19056C3.78642 2.66675 3.39883 2.82729 3.11306 3.11306C2.82729 3.39883 2.66675 3.78642 2.66675 4.19056V11.8096C2.66675 12.2137 2.82729 12.6013 3.11306 12.8871C3.39883 13.1729 3.78642 13.3334 4.19056 13.3334H12.5715C12.9756 13.3334 13.3632 13.1729 13.649 12.8871C13.9348 12.6013 14.0953 12.2137 14.0953 11.8096V8.76199",
    stroke: "#2B383C",
    strokeWidth: 0.761905,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSystemUiconsExternal);
export default __webpack_public_path__ + "static/media/system-uicons_external.bf894530aec18971e02f04211b943334.svg";
export { ForwardRef as ReactComponent };